import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { PlusIcon } from 'lucide-react';

/**
 * Hover-only plus separator between questions.
 *
 * - Appears as a subtle line with a plus icon when hovering its row.
 * - On click, opens the `QuizBuilderQuestionDialog`.
 * - The actual insertion logic is handled via the `onSelect` prop.
 */
export default function QuizBuilderQuestionSeparator(quizBuilderQuestionSeparatorProps: ComponentProps<'button'>) {
  const { className, ...props } = quizBuilderQuestionSeparatorProps;

  return (
    <button type="button" className={cn('w-full h-3 group relative cursor-pointer', 'shrink-0', className)} {...props}>
      <div className="pointer-events-none absolute inset-0 flex items-center opacity-0 transition-opacity delay-0 duration-100 group-hover:opacity-100 group-hover:delay-150">
        <div className="flex w-full items-center px-1">
          <span className="bg-fill-gray flex size-3 items-center justify-center rounded-full">
            <PlusIcon className="text-text-on-gray-fill size-2.5" />
          </span>
          <span className="bg-fill-gray ms-px h-0.5 w-full grow rounded-sm" />
        </div>
      </div>
    </button>
  );
}
